var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-error p-5 bg-dark"},[_c('b-container',[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{staticClass:"text-white",attrs:{"md":"10","lg":"8"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }